import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Globals } from 'src/shared/globals';
import { EventEmitterService } from '../../global_services/event-emitter.service';
import { Router } from '@angular/router';
// import { ToasterService } from './toaster.service';

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class AuthenticationService {
  constructor(private http: HttpClient,
  private global: Globals,
  private eventEmitterService: EventEmitterService,
  private router: Router) { }
  logout() {
 localStorage.removeItem('currentUser');
 this.HeaderComponentReInitiateFunction();
 this.router.navigate(['/login-register']);
  }

  HeaderComponentReInitiateFunction() {
 this.eventEmitterService.ComponentManipulator();
  }

  login(_username: string, _password: string) {
 return this.http.post<any>(`${this.global.apiUrl}Account/Login`, { username: _username, password: _password })
   .pipe(map(user => {
  return user;
   }));
  }
}
